import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';
import { useAuth } from './AuthContext';

const InstancesContext = createContext();

export const useInstances = () => {
  const context = useContext(InstancesContext);
  if (!context) {
    throw new Error('useInstances deve ser usado dentro de InstancesProvider');
  }
  return context;
};

export const InstancesProvider = ({ children }) => {
  const [instances, setInstances] = useState([]);
  const [loading, setLoading] = useState(true);
  // Pool de disparo por persona: liberado cliente a cliente pelo admin.
  const [poolHabilitado, setPoolHabilitado] = useState(false);
  const { user } = useAuth();

  const loadInstances = async () => {
    if (!user?.cliente_id) return;
    
    try {
      setLoading(true);
      const response = await api.get('/instancias-whatsapp', {
        params: { cliente_id: user.cliente_id }
      });
      setInstances(response.data || []);
    } catch (error) {
      console.error('Erro ao carregar instâncias:', error);
    } finally {
      setLoading(false);
    }
  };

  // Buscado aqui, e não do login, porque o login guarda só o usuário — a flag
  // ficaria congelada e o cliente precisaria sair e entrar para o menu aparecer
  // depois de habilitado.
  const loadPoolHabilitado = async () => {
    if (!user?.cliente_id) return;
    try {
      const { data } = await api.get(`/clientes/${user.cliente_id}`);
      setPoolHabilitado(!!data?.pool_disparo_habilitado);
    } catch (error) {
      // Falha aqui só esconde o item de menu; não pode derrubar o layout.
      setPoolHabilitado(false);
    }
  };

  useEffect(() => {
    loadInstances();
    loadPoolHabilitado();
  }, [user?.cliente_id]);

  const hasZApiInstance = instances.some(i => i.provider === 'z-api' && i.ativo);
  const hasMetaInstance = instances.some(i => i.provider === 'meta-api' && i.ativo && i.status === 'conectada');
  const hasInstagramInstance = instances.some(i => i.platform === 'instagram' && i.ativo && i.status === 'conectada');

  const value = {
    instances,
    loading,
    hasZApiInstance,
    hasMetaInstance,
    hasInstagramInstance,
    poolHabilitado,
    refreshInstances: loadInstances
  };

  return (
    <InstancesContext.Provider value={value}>
      {children}
    </InstancesContext.Provider>
  );
};
